module.exports = __webpack_public_path__ + "img/hometopone.8528200a.jpg";